import * as React from 'react';

import { SITE_SURVEY_CTA, SITE_SURVEY_PATH } from '@src/config/constants';
import { HaldiButton } from '@src/routes/common/components/HaldiButton';

export interface AboutGetStartedProps {
  className?: string;
}

/**
 * @name AboutGetStarted
 * @description A simple CTA component to nudge the user towards the Survey
 */
export const AboutGetStarted = (_props: AboutGetStartedProps) => {
  return (
    <div className="bg-seaSalt p-4">
      <div className="mx-auto max-w-3xl text-center">
        <h3 className="about-heading">Let's get started</h3>
        <div>
          <HaldiButton
            bordersX="rust"
            className="m-auto mb-8"
            href={SITE_SURVEY_PATH}
          >
            {SITE_SURVEY_CTA}
          </HaldiButton>
        </div>
      </div>
    </div>
  );
};
